import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { News } from 'app/shared/models/news.model';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
  selector: 'app-news-preview',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './news-preview.component.html',
  styleUrl: './news-preview.component.scss'
})
export class NewsPreviewComponent {
  @Input() news!: News[];
  @Input() newsItem!: News;
  @Input() showMenu: boolean = false;

  @Output() onView = new EventEmitter<News>();
  @Output() onEdit = new EventEmitter<News>();
  @Output() onDelete = new EventEmitter<News>();

  constructor(private route: ActivatedRoute, public helperService: HelperService) {}

  getNewsLink(newsId: number): string {
    const isAdmin = this.route.snapshot.url.some(segment => segment.path === 'admin');
    return isAdmin ? `/admin/news/${newsId}` : `/news-details/${newsId}`;
  }

  viewNews() {
    this.onView.emit(this.newsItem);
  }

  editNews() {
    this.onEdit.emit(this.newsItem);
  }

  deleteNews() {
    this.onDelete.emit(this.newsItem);
  }
}
